import React from 'react';
import SectionTitle from './SectionTitle';
import ScrollReveal from './ScrollReveal';

const AboutSection = () => {
  return (
    <section id="about" className="section" style={styles.section}>
      <ScrollReveal>
        <SectionTitle text="ABOUT" />
      </ScrollReveal>

      <ScrollReveal delay={300}>
        <div style={styles.terminal}>
          <div style={styles.terminalHeader}>
            <div style={styles.terminalButtonRed}></div>
            <div style={styles.terminalButtonYellow}></div>
            <div style={styles.terminalButtonGreen}></div>
            <div style={styles.terminalTitle}>user_profile.txt</div>
          </div>
          <div style={styles.terminalBody}>
            <p style={styles.terminalText}>&gt; Initializing personal data...</p>
            <p style={styles.terminalText}>&gt; Name: Tomer Katz</p>
            <p style={styles.terminalText}>&gt; Status: Online</p>
            <p style={styles.terminalText}>&gt; Description: Security researcher and developer with 5+ years in cybersecurity. Persistent problem solver with a drive to master new technologies.</p>
            <p style={styles.terminalText}>&gt; Location: Israel</p>
            <p style={styles.blinkingCursor}>_</p>
          </div>
        </div>
      </ScrollReveal>
    </section>
  );
};

const styles = {
  section: {
    padding: '3rem 1rem',
    maxWidth: '1200px',
    margin: '0 auto 4rem',
    position: 'relative',
  },
  terminal: {
    backgroundColor: 'rgba(0, 0, 0, 0.8)',
    borderRadius: '10px',
    border: '1px solid #0f0',
    boxShadow: '0 0 10px #0f0',
    overflow: 'hidden',
    margin: '2rem auto',
    maxWidth: '800px',
  },
  terminalHeader: {
    backgroundColor: '#0F0F0F',
    padding: '0.5rem 1rem',
    display: 'flex',
    alignItems: 'center',
  },
  terminalButtonRed: {
    width: '12px',
    height: '12px',
    borderRadius: '50%',
    marginRight: '6px',
    backgroundColor: '#ff5f56',
    boxShadow: '0 0 2px #ff5f56',
  },
  terminalButtonYellow: {
    width: '12px',
    height: '12px',
    borderRadius: '50%',
    marginRight: '6px',
    backgroundColor: '#ffbd2e',
    boxShadow: '0 0 2px #ffbd2e',
  },
  terminalButtonGreen: {
    width: '12px',
    height: '12px',
    borderRadius: '50%',
    marginRight: '6px',
    backgroundColor: '#27c93f',
    boxShadow: '0 0 2px #27c93f',
  },
  terminalTitle: {
    marginLeft: 'auto',
    marginRight: 'auto',
    fontSize: '0.8rem',
    color: '#e0e0e0',
  },
  terminalBody: {
    padding: '1.5rem',
    fontFamily: '"VT323", monospace',
    color: '#5aff5a',
    fontSize: '1.2rem',
  },
  terminalText: {
    marginBottom: '0.5rem',
  },
  blinkingCursor: {
    animation: 'blink 1s infinite',
    marginBottom: '0',
  }
};

export default AboutSection; 